import { BmPage } from './BmPage'

export function MaintenancePage() {
  return (
    <BmPage title="Maintenance" description="Lab /maintenance">
      <p>The bookmaker console is under maintenance. Please try again later.</p>
    </BmPage>
  )
}
